'use client';
import { useEffect } from 'react';

import { useRouter } from 'next/navigation';

export default function NavigationBridgeListener() {
    const router = useRouter();

    useEffect(() => {
        // Vérifier s'il y a un message en attente
        const pendingDataStr = sessionStorage.getItem('pending_boond_navigation');

        if (pendingDataStr) {
            try {
                const data = JSON.parse(pendingDataStr);

                // Vérification de sécurité (Expiration après 10 secondes)
                // Si la redirection a pris trop de temps ou date d'une vieille session, on ignore.
                const isRecent = (Date.now() - data.timestamp) < 10000;

                if (isRecent) {
                    sessionStorage.removeItem('pending_boond_navigation');

                    const queryParams = new URLSearchParams(data.params).toString();
                    const targetUrl = `${data.targetPath}?${queryParams}`;

                    console.log('Pont Iframe activé : Redirection vers', targetUrl);

                    router.replace(targetUrl);
                } else {
                    // Nettoyage si c'est trop vieux
                    sessionStorage.removeItem('pending_boond_navigation');
                }
            } catch (e) {
                console.error('Erreur lecture pont navigation', e);
                sessionStorage.removeItem('pending_boond_navigation');
            }
        }
    }, [router]);

    return null;
}